import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { Badge } from "../../../shared/Badge";
var getBadgeMinWidth = function getBadgeMinWidth(buttonSize) {
  return buttonSize.includes("small") ? 1 : 5;
};
var getBadgeOffset = function getBadgeOffset(buttonSize) {
  switch (buttonSize) {
    case "small":
    case "xsmall":
      return "-5.5px";
    case "medium":
    case "large":
    default:
      return "-7.5px";
  }
};
export var ButtonBadge = styled(Badge)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    top: ", ";\n    right: ", ";\n    // these next two numbers differ from figma because of the .5px padding figma gives to text\n    border-radius: 7px;\n    padding: 0px 3.5px;\n    border-width: 1px;\n    min-width: ", "px;\n"])), function (_ref) {
  var buttonSize = _ref.buttonSize;
  return getBadgeOffset(buttonSize);
}, function (_ref2) {
  var buttonSize = _ref2.buttonSize;
  return getBadgeOffset(buttonSize);
}, function (_ref3) {
  var buttonSize = _ref3.buttonSize;
  return getBadgeMinWidth(buttonSize);
});
//# sourceMappingURL=ButtonBadge.js.map